var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53 9.85C5.3 8.46 6.78 7.64 7.64 6.41C8.55 5.12 8.04 2.71 5.46 2.71C3.77 2.71 2.94 3.99 2.59 5.05L0 3.96C0.71 1.83 2.64 0 5.45 0C7.8 0 9.41 1.07 10.23 2.41C10.93 3.56 11.34 5.71 10.26 7.31C9.06 9.08 7.91 9.62 7.29 10.76C7.04 11.22 6.94 11.52 6.94 13H4.05C4.04 12.22 3.92 10.95 4.53 9.85ZM7.46 17C7.46 18.1 6.56 19 5.46 19C4.36 19 3.46 18.1 3.46 17C3.46 15.9 4.36 15 5.46 15C6.56 15 7.46 15.9 7.46 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.46c076ab0bdfeb8144baef1759e33106.svg";
export { ForwardRef as ReactComponent };